
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalTShape as ObiBuoyConicalTShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-t-shape.js';
 
 
 

 
 export const ObiBuoyConicalTShape = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-t-shape',
   elementClass: ObiBuoyConicalTShapeElement,
   events: {
     
   }
  });
 
 